import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import { listPopup } from '../../../lib/list-styles'
import { Interactive } from '../../interactive'
import type { PartProps } from '../../../lib/part-props'
import { useKeyboardFinalFocus } from '../../../hooks/use-keyboard-final-focus'

interface ContextMenuPopupProps extends PartProps<BaseContextMenu.Popup.Props> {
  className?: string
}

/**
 * Registers its bounds in the overlay for the same reason `Menu.Popup` does. A
 * right-click opens it, so it hands focus back to the row only when the keyboard
 * did instead.
 */
function ContextMenuPopup({ className, children, ...props }: ContextMenuPopupProps) {
  // Mounts as the menu opens.
  const finalFocus = useKeyboardFinalFocus(true)
  return (
    <BaseContextMenu.Popup className={twMerge(listPopup, 'relative', className)} finalFocus={finalFocus} {...props}>
      <Interactive>{children}</Interactive>
    </BaseContextMenu.Popup>
  )
}

export { ContextMenuPopup }
